import {UserRoleEnum} from '../helpers/enums';

export interface Address {
  street: string;
  streetNumber: string;
  postalCode: string;
  city: string;
  province: string;
  region: string;
  country: string;
}

export interface UserProfile {
  avatar: string;
  name: string;
  surname: string;
  role: UserRoleEnum
  email: string;
  pec: string;
  isLegacy:boolean;
  mobilePhoneNumber: string;
  landlinePhoneNumber: string;
  fiscalCode: string;
  agreementProfiling: boolean;
  agreementMarketing: boolean;
  businessName: string;
  billingAddress: Address;
  legalAddress: Address;
  headOfficeAddress: Address;
  profilePicture: string;
}

export interface onBoardingRequest {
  // name: string;
  // surname: string;
  // role: UserRoleEnum;
  // email: string;
  // pec: string;
  // mobilePhoneNumber: string;
  // landlinePhoneNumber: string;
  // fax: string;
  // fiscalCode: string;
  // agreementProfiling: boolean;
  // agreementMarketing: boolean;
  // businessName: string;
  // legalAddress: Address;
  // headOfficeAddress: Address;
  // operatorCity: string;
  // customerCity: string;
  role: string,
  name: string,
  surname: string,
  fax: string,
  mobilePhoneNumber: string,
  email: string,
  fiscalCode: string,
}
export interface onBoardingRes {
  outcome: string;
}

export interface User {}

export interface UpdateProfilePictureReq {
  fileName: string
}


export class ProfileImage {
  static makeData(name: any): UpdateProfilePictureReq {
    return {
      fileName: name

    } as UpdateProfilePictureReq
  }
}

